import RestClient from "@/api/utils/baseRestClient";
import waitForTask from "@/api/utils/waitForTask";
import { atmoClient } from "@/setup/clients/atmoClient";

class ConstatRestClient extends RestClient {
  async detectionByInstallation(form) {
    const url = this.buildUrl("detection_by_installation");
    const { data } = await this.client.post(url, this.toSnake({ ...form }));
    const detections =
      data.detections ?? (await this.waitForDetection(data.task_id));
    return detections.map((item) => this.toCamel(item));
  }

  async waitForDetection(taskId) {
    const { detections } = await waitForTask(
      this.client,
      this.buildUrl(`detection_by_installation/${taskId}`),
      `Constat detection task ${taskId}`
    );
    return detections;
  }
}

export const constatRestClient = new ConstatRestClient(atmoClient, "constats");
